export function fixed_float(n: number, digits: number = 1) {
  return Number(n.toFixed(digits));
}